import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { AllocationLogConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AllocationLogService } from './api/allocationLog.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class AllocationLogApiModule {
    public static forRoot(configurationFactory: () => AllocationLogConfiguration): ModuleWithProviders<AllocationLogApiModule> {
        return {
            ngModule: AllocationLogApiModule,
            providers: [ { provide: AllocationLogConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: AllocationLogApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('AllocationLogApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
